import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export type AdminProfileDTO = {
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  img_url?: string | null;
  phone?: string | null;
  role?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

type AdminProfileResponse = {
  data?: AdminProfileDTO;
  error?: ApiError;
};

// The API returns the record either bare or wrapped in { data }, depending on
// the endpoint, so unwrap defensively.
const unwrap = (payload: unknown): AdminProfileDTO => {
  const body = payload as { data?: AdminProfileDTO } & AdminProfileDTO;
  return body?.data ?? body;
};

const toApiError = (error: unknown): ApiError => {
  const err = error as {
    response?: { status: number; data: { message?: string; error?: string } };
  };
  if (err?.response) {
    return {
      statusCode: err.response.status,
      message: err.response.data?.message,
      error: err.response.data?.error,
    } as ApiError;
  }
  return { statusCode: 500, message: "An unexpected error occurred" } as ApiError;
};

/** Signed-in admin's own record (`GET /admin/`). */
export const getAdminProfile = async (): Promise<AdminProfileResponse> => {
  try {
    const response = await axios.get(`/admin/`);
    return { data: unwrap(response.data) };
  } catch (error) {
    return { error: toApiError(error) };
  }
};

/** Sales user's own record — the sales API is id-scoped (`GET /sales/:id`). */
export const getSalesProfile = async (
  id: string
): Promise<AdminProfileResponse> => {
  try {
    const response = await axios.get(`/sales/${id}`);
    return { data: unwrap(response.data) };
  } catch (error) {
    return { error: toApiError(error) };
  }
};
